import React from 'react';
import { Button } from './Button';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-id="element-2916" data-mp="1se1xfpj94sqo">
      <div className="h-16 w-16 bg-white/5 rounded-full flex items-center justify-center mb-4" data-id="element-2917" data-mp="vpm7hsc8chd1">
        <Icon className="h-8 w-8 text-white/40" data-id="element-2918" data-mp="10ogxbe8m766n" />
      </div>
      <h3 className="text-lg font-semibold text-white mb-2" data-id="element-2919" data-mp="14p9agiklxv87">{title}</h3>
      <p className="text-white/50 max-w-sm mb-6" data-id="element-2920" data-mp="14mwidcl4y4hf">{description}</p>
      {actionLabel && onAction && <Button onClick={onAction} variant="secondary" data-id="element-2921" data-mp="19htyf3gu1e3t">
          {actionLabel}
        </Button>}
    </div>;
}